const mapStyle = [
	{
	  "stylers": [
		{
		  "saturation": -100
		}
	  ]
	},
	{
	  "featureType": "landscape.man_made",
	  "elementType": "geometry.fill",
	  "stylers": [
		{
		  "saturation": -100
		}
	  ]
	},
	{
	  "featureType": "landscape.man_made",
	  "elementType": "geometry.stroke",
	  "stylers": [
		{
		  "color": "#c9c9c9"
		}
	  ]
	},
	{
	  "featureType": "poi",
	  "stylers": [
		{
		  "visibility": "off"
		}
	  ]
	},
	{
	  "featureType": "poi.business",
	  "elementType": "labels",
	  "stylers": [
		{
		  "visibility": "off"
		}
	  ]
	},
	{
	  "featureType": "poi.place_of_worship",
	  "stylers": [
		{
		  "visibility": "off"
		}
	  ]
	},
	{
	  "featureType": "road",
	  "elementType": "labels.icon",
	  "stylers": [
		{
		  "saturation": -100
		}
	  ]
	},
	{
	  "featureType": "road.highway",
	  "elementType": "geometry.fill",
	  "stylers": [
		{
		  "color": "#c9c9c9"
		}
	  ]
	},
	{
	  "featureType": "road.highway",
	  "elementType": "geometry.stroke",
	  "stylers": [
		{
		  "visibility": "off"
		}
	  ]
	},
	{
	  "featureType": "road.highway",
	  "elementType": "labels.text.fill",
	  "stylers": [
		{
		  "color": "#424242"
		}
	  ]
	},
	{
	  "featureType": "transit.line",
	  "elementType": "geometry.fill",
	  "stylers": [
		{
		  "color": "#c9c9c9"
		}
	  ]
	},
	{
	  "featureType": "transit.line",
	  "elementType": "labels.text",
	  "stylers": [
		{
		  "saturation": -100
		}
	  ]
	},
	{
	  "featureType": "water",
	  "elementType": "geometry.fill",
	  "stylers": [
		{
		  "color": "#b0b0b0"
		}
	  ]
	}
  ];

function _initMap(elem, options) {
	const styledMapType = new google.maps.StyledMapType(mapStyle, {
		name: "Styled Map"
	});

	let map = new google.maps.Map(elem, {
		center: {
			lat: options.lat,
			lng: options.lng
		},
		zoom: 17,
		mapTypeControl: false,
		mapTypeControlOptions: {
			mapTypeIds: ["roadmap", "styled_map"]
		}
	}); 

	map.mapTypes.set("styled_map", styledMapType);
	map.setMapTypeId("styled_map");

	const marker = new google.maps.Marker({
		position: {
			lat: options.lat,
			lng: options.lng
		},
		map: map
	});

	window.mapInitialized = 1;
}

window.initMap = () => {
	if (!jQuery('main.contact-us').length)
		return;
	
	let mapelem_one = document.getElementById("map"),
		mapelem_two = document.getElementById("map2");

	_initMap(mapelem_one, {
		lat: 38.8585105,
		lng: 23.0420864
	})
	_initMap(mapelem_two, {
		lat: 38.8774657,
		lng: 23.0414206
	})
}
